// extracted by mini-css-extract-plugin
export default {"assigneeContainer":"assignees-field-module__assigneeContainer--OmKf8"};